import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import API from '../../../../../utils'; // Adjust the path as needed

function CustomerAnalysis() {
    const [checkedValue, setCheckedValue] = useState({ customer_analysis: '' });
    const [updatedTask, setUpdatedTask] = useState(null);
    const uid = localStorage.getItem("user_id");

    // Fetch initial data
    const fetchData = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);

            const response = await axios.post(`${API.BASE_URL}${API.ENDPOINTS.get_growth_customer}`, formDataToSend, {
                headers: {
                    Authorization: `${API.AUTHORIZATION_TOKEN}`,
                },
            });

            if (response.data.status === "success") {
                setCheckedValue(response.data.data || { customer_analysis: '' });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Fetch customer data error', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Debounced save function
    const debouncedUpdateTask = useCallback(
        debounce(async (task) => {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);
            formDataToSend.append('analysis', task.value || '');

            try {
                const response = await axios.post(
                    `${API.BASE_URL}${API.ENDPOINTS.add_update_customers_analysis}`,
                    formDataToSend,
                    {
                        headers: {
                            Authorization: `${API.AUTHORIZATION_TOKEN}`,
                        },
                    }
                );

                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    fetchData();
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error("An error occurred while updating data.");
            }
        }, 1000),
        [uid]
    );

    useEffect(() => {
        if (updatedTask) {
            debouncedUpdateTask(updatedTask);
        }
    }, [updatedTask, debouncedUpdateTask]);



    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        // Update the state based on the checkbox value
        setCheckedValue({
            customer_analysis: checked ? value : ''
        });

        // Set the updated task to trigger debounced update
        setUpdatedTask({
            value: checked ? value : ''
        });
    };



    return (
        <div className="col-sm-12">
            <div className="card mt-4">
                <div className="card-header">
                    <div className='justify-content-between d-flex'>
                        <div className="">
                            <h5>Customer Analysis</h5>
                        </div>
                        <div>
                            <Link className='backto-ondriver' to="/growthframeworks/founderdriver">Back to the Founder OS Drivers of Growth</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="card-body">
                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.customer_analysis === 'Enterprise' ? '#d3f9d8' : 'white' }}
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Enterprise"
                                    checked={checkedValue.customer_analysis === 'Enterprise'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Enterprise</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • The business is focused on providing a differentiated customer experience by predicting customers’ needs and delivering personalized value.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.customer_analysis === 'Corporation' ? '#d3f9d8' : 'white' }}
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Corporation"
                                    checked={checkedValue.customer_analysis === 'Corporation'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Corporation</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • The business is focused on customer satisfaction. Customer engagement is information-led and relationship-led.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.customer_analysis === 'Startup' ? '#d3f9d8' : 'white' }}
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Startup"
                                    checked={checkedValue.customer_analysis === 'Startup'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Startup</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • The business is focused on product and service. There is a strong emphasis on sales growth.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CustomerAnalysis;
